<template>
  <div id="introduction">
    <div class="block-1 card border-0 text-center">
      <img class="illustrations" src="@/assets/gel/images/illustrations/favicon.svg">
      <div class="card-body">
        <h4 class="text-blue mb-4">What is GEL?</h4>
        <p>
          PageUp GEL offers visual style, accessible UI components, charts, editorial guidance, UX patterns, and branding released as a HTML & CSS framework, Sketch, and other PDF & AI templates and documented at gel.pageuppeople.com produced by UX team in
          order to serve 10+ web apps, a few native app and limited branding products and experiences.
        </p>
      </div>
    </div>
    <router-link class="block-2 card border-0 text-center" :to="{ name: 'principles' }">
      <img class="illustrations" src="@/assets/gel/images/illustrations/pencil.svg">
      <div class="card-body">
        <h4 class="text-blue mb-4">Design Principles</h4>
        <p
          class="text-muted"
        >Understand how we approach design for our products with our core principles.</p>
      </div>
    </router-link>
    <div class="block-3 card border-0 text-center">
      <img class="illustrations" src="@/assets/gel/images/illustrations/core.svg">
      <div class="card-body">
        <h4 class="text-blue mb-4">Foundations</h4>
        <p
          class="text-left"
        >Foundations are broken down into two levels. Digital foundations are applicable to all our digital products — think of them as the overarching brand and digital guidelines. These can be brand look, tone, formatting, and guiding principles.</p>
        <p
          class="text-left"
        >Product foundations are specific to a particular product(s), and cover guidelines for things like:</p>
        <ul class="text-left">
          <li>
            <router-link :to="{ name: 'typography' }">Typography</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'colours' }">Colour Palettes</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'iconography' }">Iconography</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'grids' }">Responsive Grids</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="block-4 card border-0 text-center" href="atoms">
      <img class="illustrations" src="@/assets/gel/images/illustrations/organisms.svg">
      <div class="card-body">
        <h4 class="text-blue mb-4">Core Components</h4>
        <p
          class="text-left"
        >It provides HTML, CSS, SASS and JavaScript to describe how all of the core interface elements should look and behave. The GUI can also be used as a point of reference for UX and UI designers.</p>
        <p
          class="text-left"
        >Atomic design is the methodology we follow. There are five distinct levels in atomic design, Atoms, Molecules, Oraganisms, Templates and Pages.</p>
      </div>
    </div>
    <router-link class="block-5 card border-0 text-center" :to="{ name: 'general' }">
      <img class="illustrations" src="@/assets/gel/images/illustrations/accessibility.svg">
      <div class="card-body">
        <h4 class="text-blue mb-4">Accessibility</h4>
        <p
          class="text-muted"
        >Products should be accessible to everyone, including those with vision, hearing, cognitive, or motor impairments.</p>
      </div>
    </router-link>

    <router-link class="block-6 card border-0 text-center" :to="{ name: 'downloads' }">
      <img
        class="illustrations"
        src="@/assets/gel/images/illustrations/folders.svg"
        alt="download"
      >
      <div class="card-body">
        <h4 class="text-blue mb-4">Downloads</h4>
        <p class="text-muted">Guidance on how and when to use resources and assets.</p>
      </div>
    </router-link>
</div>
</template>

<script>
let title = "Global Experience Language";
export default {
  name: "introduction",
  components: {},
  beforeCreate: function() {
    this.$emit("update-title", title);
    this.$emit(
      "update-tagline",
      this.$root.yamlData.introduction.introduction.description
    );
  }
};
</script>
